<div class="help">
    <iframe [src]="helpUrl | safeUrl"></iframe>
    <icon-button icon="x" class="close-btn" (click)="close()" class="close"></icon-button>
</div>